import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
  const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../pages/index/index.vue')
  },
  {
    path: '/navigation',
    name: 'Navigation',
    component: () => import('../pages/navigation/index.vue')
  },
  {
    path: '/pano',
    name: 'Pano',
    component: () => import('../pages/pano/index.vue')
  },
   {
      path: '/scenes',
      name: 'Scenes',
      component: () => import('../pages/scenes/index.vue'),
    },
    {
    path: '/sceneiframe',
    name: 'Scene',
    component: () => import('../pages/sceneiframe/index.vue'),
  },
  {
    path: '/gis',
    name: 'Gis',
    component: () => import('../pages/gis/index.vue'),
  },
     {
    path: '/antiques',
    name: 'Antiques',
    component: () => import('../pages/antiques/index.vue'),
  },
  {
    path: '/detail',
    name: 'Detail',
    component: () => import('../pages/detail/index.vue'),
  },
  {
    path: '/ebook',
    name: 'Ebook',
    component: () => import('../pages/ebook/index.vue'),
  }
  
]

const router = new VueRouter({
  routes
})

export default router
